import React from "react";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";

import { Platform, StyleSheet } from "react-native";
import AppConfig from "../config/AppConfig";
import appPages from "../appPages";

const styles = StyleSheet.create({
  scene: Platform.select({
    web: {
      width: "100%",
      maxWidth: AppConfig.MAX_WIDTH,
      margin: "auto",
      flex: 1,
    },
  }),
});

const Tab = createBottomTabNavigator();

export function RootStack(props) {
  const pages = props.pages || {};

  return (
    <Tab.Navigator
      tabBar={(p) => <pages.Footer {...p} />}
      sceneContainerStyle={styles.scene}
    >
      <Tab.Screen name="feed" options={{ title: "Home" }}>
        {(p) => <pages.HomePage {...p} controller={props.controller} />}
      </Tab.Screen>
      <Tab.Screen name={appPages.trackHome} options={{ title: "Track" }}>
        {(p) => <pages.TrackHomePage {...p} controller={props.controller} />}
      </Tab.Screen>
      <Tab.Screen
        name={appPages.reflectionPage}
        options={{ title: "Reflection" }}
      >
        {(p) => <pages.ReflectionPage {...p} controller={props.controller} />}
      </Tab.Screen>
      <Tab.Screen name={appPages.resolutionPage} options={{ title: "Goals" }}>
        {(p) => <pages.ResolutionPage {...p} controller={props.controller} />}
      </Tab.Screen>
      <Tab.Screen
        name={appPages.receivedReports}
        options={{ title: "Reports" }}
      >
        {(p) => (
          <pages.MyReportsPage
            {...p}
            controller={props.controller}
            type={"received"}
          />
        )}
      </Tab.Screen>
    </Tab.Navigator>
  );
}
